import { render, staticRenderFns } from "./SliderLayout.vue?vue&type=template&id=f76d2f54&scoped=true&"
import script from "./SliderLayout.vue?vue&type=script&lang=js&"
export * from "./SliderLayout.vue?vue&type=script&lang=js&"
import style0 from "./SliderLayout.vue?vue&type=style&index=0&id=f76d2f54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d2f54",
  null
  
)

export default component.exports